import { Modal } from "semantic-ui-react";
import EmblaCarousel from "../Carousel/EmblaCarousel";
import { useState } from "react";
import "./EmbeddedCarousel.scss";
import { ImageUrl } from "../../../types/types";

interface EmbeddedCarouselProps {
	imageUrls: ImageUrl[];
}

export default function EmbeddedCarousel({ imageUrls }: EmbeddedCarouselProps) {
	const [clickedImage, setClickedImage] = useState<string>("");

	if (!imageUrls || !imageUrls.length) {
		return <></>;
	}

	const thumbnails = imageUrls.map((urls) => {
		const numSizes = Object.keys(urls)
			.filter((size) => size !== "original")
			.map((size) => Number(size));
		const smallestThumb = Math.min.apply(Math, numSizes);
		if (!isFinite(smallestThumb)) {
			return urls["original"];
		}

		return urls[smallestThumb];
	});
	const originals = imageUrls.map((urls) => urls["original"]);

	const onClick = (index: number) => {
		if (typeof originals[index] === "undefined") {
			// fallback to the thumbnail if the original is not available
			setClickedImage(thumbnails[index]);
		}

		setClickedImage(originals[index]);
	};

	return (
		<Modal
			id="property-image-popup"
			trigger={
				imageUrls.length > 1 ? (
					<EmblaCarousel slides={thumbnails.map((url) => ({ url }))} onClick={onClick} />
				) : (
					<img className={"single-image"} src={thumbnails[0]} alt="" onClick={() => onClick(0)} />
				)
			}
			content={<img src={clickedImage} alt="" />}
		/>
	);
}
